module.exports = __webpack_public_path__ + "static/media/distance.ed48c016.svg";